
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 455","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M472.5.9h-433C17.8.9 0 18.7 0 40.4v254.7c0 21.7 17.8 39.5 39.5 39.5h165.6l-12.7 86.6h-82.8c-3.8 0-6.4 2.5-6.4 6.4v15.3c0 3.8 2.5 6.4 6.4 6.4h293c3.8 0 6.4-2.5 6.4-6.4v-15.3c0-3.8-2.5-6.4-6.4-6.4h-82.8l-12.7-86.6h165.6c21.7 0 39.5-17.8 39.5-39.5V40.4C512 18.7 495.4.9 472.5.9zM221.6 421.2l8.9-61.1h50.9l8.9 61.1zM484 295.1c0 6.4-5.1 11.5-11.5 11.5h-433c-6.4 0-11.5-5.1-11.5-11.5V79.8h456zm0-243.3H28V40.4c0-6.4 5.1-11.5 11.5-11.5h433c6.4 0 11.5 5.1 11.5 11.5z"}}),_c('path',{attrs:{"d":"M159.2 283.6h129.9c3.8 0 6.4-2.5 6.4-6.4V109.1c0-3.8-2.5-6.4-5.1-6.4H159.2c-3.8 0-6.4 2.5-6.4 6.4v168.1c0 3.9 2.6 6.4 6.4 6.4zm21.7-152.8h86.6v124.8h-86.6zM324.8 283.6h129.9c3.8 0 6.4-2.5 6.4-6.4V109.1c0-3.8-2.5-6.4-5.1-6.4H324.8c-3.8 0-6.4 2.5-6.4 6.4v168.1c0 3.9 2.6 6.4 6.4 6.4zm21.6-152.8H433v124.8h-86.6zM58.6 130.8h63.7c3.8 0 6.4-2.5 6.4-6.4v-15.3c0-3.8-2.5-6.4-6.4-6.4H58.6c-3.8 0-6.4 2.5-6.4 6.4v15.3c0 3.8 2.6 6.4 6.4 6.4zM58.6 181.7h63.7c3.8 0 6.4-2.5 6.4-6.4V160c0-3.8-2.5-6.4-6.4-6.4H58.6c-3.8 0-6.4 2.5-6.4 6.4v15.3c0 3.9 2.6 6.4 6.4 6.4zM58.6 232.7h63.7c3.8 0 6.4-2.5 6.4-6.4V211c0-3.8-2.5-6.4-6.4-6.4H58.6c-3.8 0-6.4 2.5-6.4 6.4v15.3c0 3.8 2.6 6.4 6.4 6.4zM58.6 283.6h63.7c3.8 0 6.4-2.5 6.4-6.4V262c0-3.8-2.5-6.4-6.4-6.4H58.6c-3.8 0-6.4 2.5-6.4 6.4v15.3c0 3.8 2.6 6.3 6.4 6.3z"}})])])
          )
        }
      }
    